const rootConfig = document.getElementById('root-config');
const appConfig = rootConfig ? JSON.parse(rootConfig.dataset.config) : {};
const Config = {
    'csrf_token': '',
    'empty_csrf_token': '',
    'can_leave_review': false,
    'max_connected_calendars': 1,
    'max_connected_event_types': 1,
    'dark_mode': false,
    'timezones': [],
    'show_modal_allow_login_as_user': false,
    'is_default_company': false,
    'help_center_domain': 'help.SimplyMeet.me',
    'show_paid_org_consultation_banner': false,
    'user': {
        'id': '',
        'enabled': true,
        'slug': '',
        'email': '',
        'fullName': '',
        'timezone': '',
        'date_format': '',
        'time_format': '',
        'sunday_is_first_day': false,
        'is_rtl': false,
        'locale': '',
        'is_owner': false,
        'has_trial_subscription': false,
        'has_paid_subscription': false,
        'has_current_subscription': false,
        'subscription_expires_at': null,
        'trial_days_left': 0,
        'has_organization': false,
        'branding_enabled': false,
        'welcome_tour_step': null,
        'calendar_event_name': "",
        'phone_number': "",
        'public_url': "",
        'is_onboarding_skipped': false,
        'avatar_path' : '',
        'oauth_providers': [],
    },
    'enabled_integrations': {
        'simplypay': false,
        'user_simplypay': false,
        'organization_simplypay': false,
        'sms': false,
        'zoom': false,
        'whereby': false,
        'kopano_meet': false,
        'flexible_duration': false,
        'multiple_meeting': false,
        'event_type_tag': false,
        'routing_form': false,
        'multiple_email': false,
        'google_meet': false,
        'microsoft_teams': false,
        'approve_event': false,
        'okta': false,
    },
    'path': {
        'host': '',
        'help_url': '',
        'acl_rules': '',
        'payment': '',
        'open_simplypay_event': '',
        'dashboard': {
            'review': {
                'leave': ''
            }
        },
        'search': {
            'relevant_resources': '',
            'stream_gpt': '',
        },
        'file': {
            'image': '',
        },
        'appearance': {
            'user': '',
            'organization': '',
        },
        'widget': {
            'user': '',
            'organization': '',
        },
        'calendar_integration': {
            'calendar_account_list': '',
            'calendar_check_conflicts': '',
            'calendar_check_external': '',
            'calendar_event_name_type': '',
            'calendar_default': '',
        },
        'calendar': {
            'event': {
                'list': '',
            },
            'event_type': {
                'list': '',
            }
        },
        'directory': {
            'is_in_directory': '',
            'company_save': '',
            'company_delete': '',
        },
        'affiliate': {
          'get': '',
        },
        'event': {
            'invite_participants': '',
            'cancel': '',
            'edit': '',
            'cancel_list': '',
            'delete_list': '',
            'no_show': '',
            'reschedule': '',
            'create': '',
            'notes': '',
            'list': '',
            'event_list_page': '',
            'resend_notification': '',
        },
        'approve_event': {
            'approve': '',
            'cancel': '',
            'approve_list': '',
            'cancel_list': '',
        },
        'poll': {
            'list': '',
            'create': '',
            'public_poll_result': '',
        },
        'routing_form': {
            'list': '',
            'public_routing_form_result': '',
            'result_delete': '',
            'result_delete_list': '',
        },
        'export': {
            'list': '',
            'generate': '',
            'download': '',
        },
        'welcome_tour': {
            'skip_step': '',
            'event_type': '',
        },
        'event_type': {
            'list': '',
            'availability': ''
        },
        'single_use_link': {
            'list': '',
        },
        'organization': {
            'tag': {
                'list': ''
            },
            'leave': ''
        },
        'organization_role': {
            'list': '',
            'update' : '',
        },
        'user_event_type_tag': {
            'list': ''
        },
        'event_type_tag': {
            'list': ''
        },
        'news': {
            'list': '',
            'view': ''
        },
        'availability_rule': {
            'list': ''
        },
        'availability': {
            'list': ''
        },
        'user': {
            'list': '',
            'organization_tag': {
                'list': ''
            },
            'skip_tutorial': '',
            'skip_onboarding': '',
            'set_timezone': '',
            'allow_login_as_user': '',
            'generate_user_login_url': '',
            'change_email': '',
            'change_password': '',
            'second_factor_reset': '',
            'delete': '',
        },
        'user_relation': {
            'list': '',
            'login': '',
        },
        'custom_translation': {
            'user': {
                'list': '',
            },
            'organization': {
                'list': '',
            }
        },
        'tax': {
            'user': {
                'list': '',
            },
            'organization': {
                'list': '',
            }
        },
        'booking': {
            'availability': ''
        },
        'chart': {
            'list_status': '',
            'hour': '',
            'status': '',
        },
        'api_key': {
            'list': '',
        },
        'multiple_email': {
            'config': '',
        },
        'login_qr': {
            'generate': '',
        },
        'reauth': '',
        'oauth': {
            'disconnect': '',
            'connect': '',
        },
    },
    ...appConfig
};

export default Config;